import React, { useRef } from "react";
import "@/stylesheets/components/generic/Carousel/Carousel.scss";
import Slider, { Settings } from "react-slick";
import DeviceContext from "@/components/generic/customHooks/indentifyDevice";
import HandleResize from "@/components/generic/customHooks/HandleResize";
import { useEffect } from "react";

interface IGenericCarousel {
  children: React.ReactNode;
  settings: Settings;
  noLeft?: boolean;
  showArrowsOnBoth?: boolean;
}

const GenericCarousel = (props: IGenericCarousel) => {
  const device = DeviceContext();
  const [active, setActive] = React.useState(0);
  const sliderRef = useRef(null);
  const ref = useRef(null);
  const marginValue = HandleResize();
  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        const owlStageOuter = ref.current.querySelector(".slick-list");
        if (owlStageOuter && !props.noLeft) {
          owlStageOuter.style.marginLeft = marginValue + "px";
        }
      }
    };

    handleResize();
  }, [ref.current, marginValue]);

  return (
    <div ref={ref}>
      <Slider
        beforeChange={(current: any, next: any) => {
          setActive(next);
        }}
        // adaptiveHeight
        arrows={props.showArrowsOnBoth === true ? true : device?.isDesktop}
        touchMove
        swipe={!device?.isDesktop}
        dots
        ref={sliderRef}
        dotsClass="slick-dots custom-dots"
        customPaging={(i: any) => {
          return (
            <button
              className={`custom-dot ${
                i === Math.ceil(active) ? "active" : ""
              }`}
            >
              {i + 1}
            </button>
          );
        }}
        appendDots={(dots: any) => (
          <div>
            <ul>{dots}</ul>
          </div>
        )}
        {...props.settings}
      >
        {props.children}
      </Slider>
    </div>
  );
};

export default GenericCarousel;
